/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from "react";
export var CloudinaryPlayerContext = createContext({ player: null, setPlayer: function () { } });
